import { FBF_CloudCallable } from '@rabbit/firebase/adapter';
import {
  MainGroupCreateDto,
  MainGroupUpdateDto,
  DocIdParamDto,
} from '@rabbit/nest/api';
import { DTMainGroup } from '@rabbit/data/types';

export const nestApiCreateMainGroup = FBF_CloudCallable<
  MainGroupCreateDto,
  DTMainGroup
>('api/main-groups|POST');

export const nestApiUpdateMainGroup = FBF_CloudCallable<
  DocIdParamDto & MainGroupUpdateDto,
  DTMainGroup
>('api/main-groups/:docid|PUT');

export const nestApiDisableMainGroup = FBF_CloudCallable<
  DocIdParamDto,
  boolean
>('api/main-groups/:docid/disable|DELETE');

export const nestApiEnableMainGroup = FBF_CloudCallable<
  DocIdParamDto,
  boolean
>('api/main-groups/:docid/enable|PATCH');

export const nestApiGetMainGroup = FBF_CloudCallable<
  DocIdParamDto,
  DTMainGroup
>('api/main-groups/:docid|GET');

export const nestApiGetAllMainGroups = FBF_CloudCallable<
  void,
  DTMainGroup[]
>('api/main-groups|GET');

export const nestApiGetAllMainGroupsBySharedLocation = FBF_CloudCallable<
  void,
  DTMainGroup[]
>('api/main-groups/shared-location|GET');
